import { createContext, useContext } from 'react';
import { CTranslations } from './translations';
import { CPortalLayer } from './portals';

export interface CProviderContextValue {
  translations: CTranslations;
  getPortalContainer(layer: CPortalLayer): HTMLElement | null;
}

export const CProviderContext = createContext<CProviderContextValue | undefined>(undefined);

export function useCProvider(): CProviderContextValue {
  const context = useContext(CProviderContext);
  if (!context) {
    throw new Error('useCProvider must be used within <CProvider>. Wrap your app with <CProvider>.');
  }
  return context;
}

export function useCTranslations(): CTranslations {
  return useCProvider().translations;
}

export function useCPortal(layer: CPortalLayer): HTMLElement | null {
  return useCProvider().getPortalContainer(layer);
}
